import {api_hsbc_payment_initiate,api_hsbc_account_variables,get_axios_hsbc_instance,errorHandler,get_axios_hsbc_instance_payment_details} from '@/apis/variables.js';
var axios_instance_post = get_axios_hsbc_instance(api_hsbc_account_variables.SERVICE_HSBC_ADD_ACCOUNT_DETAILS)
var axios_instance_approved_details = get_axios_hsbc_instance(api_hsbc_account_variables.SERVICE_HSBC_PAYMENT_APPROVED)
var axios_instance_payment_initiate = get_axios_hsbc_instance(api_hsbc_account_variables.SERVICE_HSBC_PAYMENT_INITIATE)
var axios_instance_payment_status = get_axios_hsbc_instance(api_hsbc_account_variables.SERVICE_HSBC_PAYMENT_STATUS)
var axios_instace_get_payment_details = get_axios_hsbc_instance_payment_details(api_hsbc_payment_initiate.SERVICE_HSBC_PAYMENT_DETAILS)
const state = {
    entityWiseData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};
const getters={
  editMode: (state)=>{
     return state,editMode
  },
  record:(state)=>{
    return state.record
  }
}
 const mutations={
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        //console.log(state.record)
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
 }
  const actions={
    async createHsbcSetting({commit},payload){
        try{
            commit("setSaving",true);
            let res = await axios_instance_post.post("",payload)
            commit("setSaveing", false);
            return res;
        } catch(error){
            throw errorHandler(error.response);
        }
    },
    async fetchPaymentDetails({commit},payload){
    try{
       commit("setSaving",true);
       let res = await axios_instace_get_payment_details.post("",payload)
       commit("setSaveing",false);
       return res;
    }catch(error){
        throw errorHandler(error.reponse);
    }
    },
    async initiatePaymentDetails({commit},payload){
        try{
           commit("setSaving",true);
           let res = await axios_instance_payment_initiate.post("",payload)
           commit("setSaveing",false);
           return res;
        }catch(error){
            throw errorHandler(error.reponse);
        }
        },
    async approvedPaymentDetails({commit},payload){
            try{
               commit("setSaving",true);
               console.log(payload)
               let res = await axios_instance_approved_details.post("",payload)
               commit("setSaveing",false);
               return res;
            }catch(error){
                throw errorHandler(error.reponse);
            }
            },
    async postApprovedPaymentStatus({commit},payload){
             try{
                   commit("setSaving",true);
                   console.log(payload)
                   let res = await axios_instance_payment_status.put("",payload)
                   console.log(res)
                   commit("setSaveing",false);
                   return res;
              }catch(error){
                    throw errorHandler(error.reponse);
                }
                }
  }
export default{
    namespaced: true,
    actions,
    getters,
    state,
    mutations
}